import Model from "./base/model";

class TransporterTrt extends Model{
  resourceName() {
    return "transporter_trt";
  }

  fields() {
    return {
      transporter_id: "",
      city_id: "",
      city: "",
      transporter: { jsonApi: "hasOne", type: "transporters"},

    };
  }

}

export default new TransporterTrt();
